import React from 'react';
import { BreadcrumbComponent } from '../../Components/BreadCrumb';

/** The trail on a page reached from the Superadmin-funktioner menu. */
const SuperadminBreadcrumb: React.FC<{ title: string }> = ({ title }) => (
    <BreadcrumbComponent items={[{ text: 'Superadmin-funktioner', link: '/superadmin' }, { text: title }]} />
);

export default SuperadminBreadcrumb;
